import axios from 'axios';
import { api, headers } from '../../app/conf';

export const getRenewalConfig = (companyId, token) =>
    axios({
        method: 'get',
        url: `${api}/renewal-configs/${companyId}`,
        headers: { ...headers, 'X-Access-Token': token }
    });

export const updateRenewalConfig = (companyId, data, token) =>
    axios({
        method: 'put',
        url: `${api}/renewal-configs/${companyId}`,
        headers: { ...headers, 'X-Access-Token': token },
        data
    });
